/**
 * 設定值
 */

/**
 * 共用取option設定值
 */
export const AxiosDefaultOption = {
    /**
     * 內建功能
     */
    builtIn: {
        /**
         * 讀取遮罩 - 不顯示
         */
        loadingMask: false,
        /**
         * 錯誤回調 - 不執行
         */
        failure: false
    }
}
